import { clearCookieByName, clearTeamsCookie, getQueryString, inApp, isPrivateEnv } from './../utils/index';
import { request } from "@weapp/utils";
import { thirdParm } from "../components/m/standardLogin/type";
import { mainHost, passportHost, getCookie, encryptRsa } from '../utils';
import { publicUrl, publicUrlapi } from "../constants";
import QueryString from 'qs';


// login
export const login = (params: any) => {
  params['language'] = getCookie('langType') || 'zh_CN';
  try {
    const skinData = JSON.parse(JSON.parse(window.localStorage.getItem('e_customPageData_H5') as any)?.loginSkin) || {};
    if (skinData.pageInfo.hasOwnProperty('tenantSelfOnly')) {
      params['onlySelfTenant'] = skinData.pageInfo.tenantSelfOnly;
    }
  } catch (error) {

  }
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/login/appLogin`,
    method: "POST",
    headers: {
      "langType": getCookie('langType') || 'zh_CN',
    },
    params: params.password.length > 64 ? params : encryptRsa(params, "password")
  });
};
// login
// export const h5Login = (params: any) => {
//   return request({
//     url: passportHost() + "/papi/passport/login/h5login",
//     method: "POST",
//     headers: {
//       "langType": getCookie('langType') || 'zh_CN',
//     },
//     data: encryptRsa(params, "password"),
//   });
// };
// newLogin
export const newLogin = (params: any) => {
  if (params.password) {
    if (params.password.length <= 64) {
      params = encryptRsa(params, "password")
    }
  }
  if (window.sessionStorage.getItem('PASSPORT_LANGTYPE_CHANGED') || isPrivateEnv()) {
    params['language'] = getCookie('langType') || 'zh_CN';
  }
  let loginType = inApp() ? 'app_account' : 'h5_account';
  if (getQueryString('loginType')) {
    loginType = getQueryString('loginType');
  }
  if (!params.service) {
    params.service = `${window.passport_runInfo.weappUrl}${window.passport_runInfo?.sysLoginRedirectPath || (window.passport_runInfo?.secondFrontUrl ? `${window.passport_runInfo.secondFrontUrl}/` : ``)}`
  } else if (window.passport_runInfo?.sysLoginRedirectPath){
    let path = params.service?.split("?")[0];
    let search = params.service?.split("?")[1] ? `?${params.service?.split("?")[1]}` : '';
    let secondUrl = window.passport_runInfo?.secondFrontUrl || '';
    if (
      path === `${window.passport_runInfo.weappUrl}${secondUrl}` ||
      path === `${window.passport_runInfo.weappUrl}${secondUrl}/`
    ) {
      params.service = `${window.passport_runInfo.weappUrl}${window.passport_runInfo?.sysLoginRedirectPath}${search}`
    }
  }

  if (window.passport_runInfo?.sysLoginRedirectPath) {
    params['sysLoginRedirectPath'] = window.passport_runInfo?.sysLoginRedirectPath
  }

  try {
    const skinData = JSON.parse(JSON.parse(window.localStorage.getItem('e_customPageData_H5') as any)?.loginSkin) || {};
    if (skinData.pageInfo.hasOwnProperty('tenantSelfOnly')) {
      params['onlySelfTenant'] = skinData.pageInfo.tenantSelfOnly;
    }
  } catch (error) {

  }

  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/appnew/login/appLogin?loginType=${loginType}`,
    method: "POST",
    headers: {
      "langType": getCookie('langType') || 'zh_CN',
    },
    data: params
  });
};
export const getLangs = () => {
  return request({
    url: mainHost() + `${publicUrlapi}/papi/app/i18n/getLanguageBase`,
    method: "GET",
  });
};


export const thirdteamsLogin = (params: thirdParm, loginType?: any) => {
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/appThird/thirdLogin${loginType ? `?loginType=${loginType}` : ``}`,
    method: "POST",
    params,
  });
};
//获取账号安全登录方式配置
export const getSafeAccount = (data: any) => {
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/login/getLoginTypes`,
    method: "POST",
    data
  });
};
//检查是否展示校验码
export const checkVerifyCodeShow = (params: any) => {
  return request({
    url: mainHost() + `${publicUrlapi}/papi/passport/login/getSafetyLoginSettingConfig`,
    method: "POST",
    data: encryptRsa(params, "account")
  });
  // return request({
  //   url: mainHost() + "/papi/passport/login/getSafetyLoginSettingConfig",
  //   method: "GET",
  //   params: params
  // });
};

export const getSkinConfig = (flag: any) => {
  return request({
    url: mainHost() + `${publicUrlapi}/papi/basicserver/loginSkin/findSkinConfig?flag=${flag}`,
    method: "GET",
  });
};

export const checkLoginTeams = (params?: any) => {
  return request({
    url: mainHost() + `${publicUrlapi}/api/baseserver/layout/teamsCheck`,
    method: "POST",
    ...(params?.ETEAMSID ? { headers: { eteamsid: params?.ETEAMSID } } : {}),
    params
  });
};

export const thirdBindAccount = (params: any) => {
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/appThird/bindAccount`,
    method: "POST",
    params: encryptRsa(params, "password"),
  });
};


export const thirdSkipBindAccount = (params: any) => {
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/appThird/skipBindAccount`,
    method: "POST",
    params,
  });
};


export const adviceBind = (params: any) => {
  return request({
    url: mainHost() + `${publicUrlapi}/papi/app/basicserver/advice/bind`,
    method: "POST",
    params: encryptRsa(params, "password"),
  });
};

export const adviceThirdBind = (params: any) => {
  return request({
    url: mainHost() + `${publicUrlapi}/papi/app/basicserver/advice/bindThird`,
    method: "POST",
    params,
  });
};
export const qysCheckLogin = (params: any) => {
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/appnew/login/qysCheckLogin`,
    method: "POST",
    params,
  });
};

export const queryUserInfoSettingWhenLogin = (params: { tenantKey: string, account: string, clientInfo: string }) => {
  if (params.account){
    params = encryptRsa(params, "account")
  }
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/auxiliary/login/queryUserInfoSettingWhenLogin`,
    params
  });
};
export const sendDynamicCode = (params: { tenantKey: string, account: string }) => {
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/auxiliary/login/sendDynamicCode`,
    params
  });
};

//其他第三方app登录---开放平台
export const openApiLogin = (data: { appkey: string, appsecret: string, account: string }) => {
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/thirdapp/openApiLogin`,
    method: "POST",
    data: {
      loginType: 1,
      ...data
    }
  });
};
//其他第三方app登录---签名
export const signLogin = (data: { signData: string, account: string, timestamp: string }) => {
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/thirdapp/signLogin`,
    method: "POST",
    data: {
      loginType: 2,
      ...data
    }
  });
};

//修改密码接口（强制重新修改）
export const resetPass = (data: { account: string, password: string, passwordCheck: string }) => {
  let postData = {
    langType: getCookie('langType') || 'zh_CN',
    account: data.account,
    password: data.password,
    passwordCheck: data.passwordCheck,
  } as any;
  if (window.e_customPageData?.tenantKey) {
    postData.tenantKey = window.e_customPageData.tenantKey;
  }
  postData = encryptRsa(postData, "password");
  postData = encryptRsa(postData, "passwordCheck");
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/password/changePasswordWithCheck`,
    method: "POST",
    data: postData
  });
};

//本机号码一键登录
export const phoneNumberOneKeyLogin = (data: any) => {
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/mobilelogin/appMobileLogin`,
    method: "POST",
    headers: {
      "langType": getCookie('langType') || 'zh_CN'
    },
    data: data
  });
}

//本机号码一键登录-绑定账号登录
export const onKeyLoginBindAccount = (data: any) => {
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/mobilelogin/bindLogin`,
    method: "POST",
    headers: {
      "langType": getCookie('langType') || 'zh_CN'
    },
    data: data
  });
}

//本机号码一键登录-绑定账号登录-换绑手机号
export const onKeyLoginChangeAccount = (data: any) => {
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/mobilelogin/changeBindLogin`,
    method: "POST",
    headers: {
      "langType": getCookie('langType') || 'zh_CN'
    },
    data: data
  });
}

export const loadOneKeyLoginConfig = (devType: string) => {
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/info/getMobileLoginInfo?devType=${devType}`,
    method: "GET",
  });
}
export const clearWeappCookie = () => {
  clearTeamsCookie();
  return request({
    url: mainHost() + `${publicUrlapi}/papi/app/baseserver/clearCookie?service=${encodeURIComponent(window.passport_runInfo.weappUrl)}`,
    method: "POST",
  });
};